<template>
  <div class="actions">
    <button class="actions__add-btn" @click="toOpen()" v-if="!isCoinSearchOpened">
      <PlusIcon /> Добавить
    </button>
    <button class="actions__add-choosen-btn" v-if="isCoinSearchOpened" @click="submitPending()">
      <PlusIcon /> Добавить выбранное
    </button>
    <button class="actions__edit-btn" @click="toggleEdit()" v-if="!isCoinSearchOpened">
      <PenIcon /> {{ isEditing ? 'Готово' : 'Редактировать' }} 
    </button>
  </div>
</template>

<script setup>
  import { useStore } from 'vuex';
  import { useBriefcaseState } from '@/Groups/Briefcase/private/composables/computedValues';
  import { reloadExternalContent } from "@/Groups/Briefcase/private/imports/reloadExternalContent";
  //---------------------------------
  import PenIcon from '@/Groups/Briefcase/private/svg/PenIcon.vue';
  import PlusIcon from '@/Groups/Briefcase/private/svg/PlusIcon.vue';
  //---------------------------------
  const store = useStore();
  //---------------------------------
  const { isEditing, isCoinSearchOpened } = useBriefcaseState();
  //---------------------------------
  //Открыть секцию поиска
  const toOpen = () => store.dispatch('Briefcase/toggleSearchSection', true);
  //Переключить режим редактирования
  const toggleEdit = () => store.dispatch('Briefcase/toggleEditing');
  //Сохранить выбранные монеты в свой портфель
  const submitPending = async () => {
    await store.dispatch('Briefcase/syncPendingAssets');
    reloadExternalContent();
  };
</script>

<style lang="scss" scoped>
  @import "./styles.scss";
</style>